<!--
 * @Descripttion: 
 * @version: 
 * @@Company: HDWB
 * @Author: cwl
 * @Date: 2022-04-12 17:29:05
 * @LastEditors: cwl
 * @LastEditTime: 2022-04-13 08:45:46
-->
<template>
  <div>
    <!-- <keep-alive> -->
    <router-view v-if="isRouterAlive"></router-view>
    <!-- </keep-alive> -->
  </div>
</template>

<script>
export default {
  name: "app",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    }
  },
  mounted() {
    //默认中文，防止刷新
    this.$utils.setStore("lang", this.$utils.getStore("lang","LOCAL")||"zh", "LOCAL");
  },
  computed: {},
  watch: {}
};
</script>

<style lang="scss" scoped>
</style>
